import React from 'react';
import Footer from './Footer';
import axios from 'axios';
import { object, string, number } from 'yup';

function PlaywrightRegister() {
  let initialState = {
    name: '',
    email: '',
    phone: '',
    courses: '--',
  };

  const [formData, setFormData] = React.useState(initialState);
  const [showAlert, setShowAlert] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  let schema = object().shape({
    name: string().required(),
    email: string().email().required(),
    phone: number().required(),
    courses: string()
      .test('is-valid', 'Please select a course', (value) => value !== '--')
      .required(),
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleReset = () => {
    setFormData(initialState);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await schema.validate(formData);
    } catch (error) {
      return alert(error.message);
    }
    setIsLoading(true);
    await axios
      .post('https://appendgooglesheet-rao5lvirzq-uc.a.run.app', formData)
      .then(() => {
        setShowAlert(true);
        handleReset();
        setIsLoading(false);
      });
  };

  return (
    <div style={{ margin: '190px 0px 0px 0px' }}>
      <div className="row align-items-start" id="contactMe">
        <div
          style={{ padding: '0 60px 0 0' }}
          className="col-sm-6"
          id="contactText"
        >
          <h1 className="text-info" style={{ fontSize: '44px' }}>
            GitHub Actions CI/CD
          </h1>
          <h2 className={'text-auto'} style={{ fontSize: '24px' }}>
            Course Objectives
          </h2>
          <p style={{ fontSize: '15px' }}>
            This course is designed to provide a comprehensive understanding of
            GitHub Actions for Continuous Integration and Continuous Deployment
            (CI/CD). Participants will learn how to automate their software
            development workflows using GitHub Actions, enabling them to build,
            test, and deploy applications efficiently. The course covers
            practical examples and best practices for implementing CI/CD
            pipelines, ensuring that participants can apply their knowledge in
            real-world scenarios.
          </p>
          <h2 className={'text-auto'} style={{ fontSize: '24px' }}>
            Who will benefit?
          </h2>
          <p style={{ fontSize: '15px' }}>
            This course is ideal for software developers, DevOps engineers,
            quality assurance professionals, and anyone involved in software
            development who wants to learn how to automate their workflows using
            GitHub Actions. It is suitable for both beginners and experienced
            professionals looking to enhance their CI/CD skills.
          </p>
          <h2 className={'text-auto'} style={{ fontSize: '24px' }}>
            Prerequisites
          </h2>
          <p style={{ fontSize: '15px' }}>
            Basic knowledge of computers and a willingness to learn programming.
            No prior programming experience required.
          </p>
          <h2 className={'text-auto'} style={{ fontSize: '24px' }}>
            Skills Gained & Benefits
          </h2>
          <ul className={'list-group'}>
            <li className={'list-group-item'} style={{ fontSize: '15px' }}>
              Proficiency in using GitHub Actions for CI/CD workflows
            </li>
            <li className={'list-group-item'} style={{ fontSize: '15px' }}>
              Skills to automate software development processes using GitHub
              Actions
            </li>
            <li className={'list-group-item'} style={{ fontSize: '15px' }}>
              Knowledge of best practices for implementing CI/CD pipelines
            </li>
            <li className={'list-group-item'} style={{ fontSize: '15px' }}>
              3 months access to private github repository with code samples,
              exercises, solutions and course materials
            </li>
          </ul>
        </div>
        <div className="col-sm-6">
          {showAlert && (
            <div className="alert alert-success" role="alert">
              Registration Successful, we will contact you soon!
            </div>
          )}
          <form className="mt-4" method="POST" onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                Name
              </label>
              <input
                type="text"
                className="form-control"
                name="name"
                value={formData.name}
                required
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={formData.email}
                required
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="Number" className="form-label">
                Phone Number
              </label>
              <input
                className="form-control"
                id="Number"
                name="phone"
                value={formData.phone}
                required
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label htmlFor={'courses'} className={'form-label'}>
                Course Start Date & Fee
              </label>
              <select
                className="form-select"
                id="courses"
                name="courses"
                value={formData.courses}
                required
                onChange={handleChange}
              >
                <option value="--" disabled>
                  --
                </option>
                <option value={'GitHub Actions Mastery Course August 23rd 2025'}>
                  October 4th 2025 -- £150
                </option>
                <option
                  value={'GitHub Actions Mastery Course October 18th 2025'}
                >
                  November 22nd 2025 -- £150
                </option>
              </select>
            </div>
            <button type="submit" className="btn btn-info" disabled={isLoading}>
              Register
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PlaywrightRegister;
